export default {
    Proactivity: {
        text: 'Проактивность'
    },
    Openness : {
        text: 'Открытость'
    },
    Responsibility : {
        text: 'Ответственность'
    },
    Participation: {
        text: 'Участие и внимание к людям'
    },
}
